export default {
  namespaced: true,
  state: {
    userAuth: {},
    token: ""
  },
  mutations: {
    updateUser: (state, payload) => {
      state.userAuth = payload;
    },
    clearUser: state => {
      state.userAuth = {};
      state.token = "";
    },
    updateToken: (state, payload) => {
      state.token = payload;
    }
  }
};
